module.exports = __webpack_public_path__ + "static/media/icon_metodologia.2ba79590.svg";